<div class="modal" id="toaster-msg-popup" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="resetToaster()">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="toaster text-center">
                    <div *ngIf="_config?.showIcon" class="icon-wrapper">
                        <img *ngIf="_config?.iconType == 'checkMark'" src="../../../assets/icons/checkMarkGreen.svg"
                            alt="">
                        <img *ngIf="_config?.iconType == 'crossMark'" src="../../../assets/icons/crossMarkRed.svg"
                            alt="">
                    </div>
                    <span class="msg">
                        {{ _config.localizeMsg ? (_config?.msg | translate) : _config?.msg }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>